import React from 'react';
import '../style/TopStories.css';
import { Link } from "react-router-dom";
import adleft from "../assets/adright.webp";
import adright from "../assets/skodanewad.png";
import city from "../assets/hondacity.webp";
import ebella from "../assets/ebella.webp";
import modely from "../assets/modely.png";
import zrv from "../assets/hondazrv.png";
import renaultad from "../assets/renaultad.png";
import pajero from "../assets/pajero.webp";
import sorento from "../assets/sorento.webp";
const TopStories = ({ onNavigate }) => {
 const stories = [
  {
    id: 1,
    title: "The Mitsubishi Pajero Is Back For 2026!",
    author: "Vishal Rajput",
    image: pajero,
    size: "large",
    page: "pajero",
  },
  {
    id: 2,
    title: "All you need to know about the Kia Sorento - Introduction",
    author: "CarsChalao Weekly",
    image: sorento,
    page: "sorento",
  },
  {
    id: 3,
    title: "Honda ZR-V India Launch Set for May 22: Hybrid Power Meets Premium CBU Luxury",
    author: "Vishal Rajput",
    image: zrv,
    page: "zrv",
  },
  {
    id: 4,
    title: "Honda City Facelift Launched in India with Sportier Styling and e:HEV Hybrid",
    author: "Market News",
    image: city,
    page: "city",
  },
  {
    id: 5,
    title: "The Electric Giant Arrives: Tesla Model Y Debuts with 2+2+2 Seating Layout and AWD",
    author: "Auto Daily",
    image: modely,
    page: "modely",
  },
];

  return (
    <section className="main-layout-wrapper">
      {/* Left Advertisement Space */}
      <aside className="side-ad left-ad">
        <div className="ad-placeholder">
            <a href="https://www.apple.com/in/shop/buy-mac">
                <img src={adleft} alt="Advertisement" />
            </a>
        </div>
      </aside>

      {/* Center Content Section */}
      <div className="center-content">
        <div className ="centre-ad">
     <a href="/best-offers/gravite">
  <img src={renaultad} alt="Advertisement" />
</a>
            </div>
        <div className="section-header">
          <h2 className="top-stories-title">TOP STORIES</h2>
          <div className="header-line"></div>
        </div>

<div className="top-stories-grid">
  {stories.map((story) => (
   <div
  key={story.id}
  onClick={() => onNavigate(story.page)}
  className={`story-card story-card-link ${
    story.size === "large" ? "large-card" : ""
  }`}
  style={{ cursor: "pointer" }}
>
      <img src={story.image} alt={story.title} className="story-image" />
      <div className="story-overlay">
        <h3 className="story-title">{story.title}</h3>
        <p className="story-meta">
          <span className="author">{story.author}</span>
        </p>
      </div>
    </div>
  ))}
</div>


      </div>

      {/* Right Advertisement Space */}
      <aside className="side-ad right-ad">
  <div className="ad-placeholder">
   <a href="/best-offers/kodiaq">
  <img src={adright} alt="Skoda Kodiaq" style={{ width: "169px", height: "596px" }} />
</a>
  </div>
</aside>
    </section>
  );
};

export default TopStories;